var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVimeo = function SvgVimeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.84 1.114c-14.76 0-26.726 11.965-26.726 26.726S13.079 54.567 27.84 54.567 54.567 42.6 54.567 27.84c0-14.76-11.966-26.726-26.727-26.726M40.093 22.69c-1.415 8.118-9.321 14.997-11.696 16.568-2.378 1.564-4.55-.633-5.334-2.294-.902-1.9-3.6-12.175-4.307-13.03s-2.829.855-2.829.855L14.9 23.414s4.307-5.243 7.584-5.894c3.474-.696 3.468 5.432 4.304 8.836.81 3.294 1.353 5.176 2.057 5.176.707 0 2.058-1.832 3.533-4.65 1.481-2.817-.061-5.306-2.954-3.535 1.156-7.071 12.083-8.775 10.669-.657"
  })));
};
export default SvgVimeo;